/**
 * GRN Model - Processes API responses for GRN data
 */

export const getGrns = (response) => {
  if (response && response.data && response.data.success === true) {
    const grns = Array.isArray(response.data.data)
      ? response.data.data.map((r) => ({
          id: r.id,
          slack: r.slack,
          grn_number: r.grn_number,
          grn_date: r.grn_date,
          invoice_number: r.invoice_number,
          invoice_date: r.invoice_date,
          quality_check_status: r.quality_check_status,
          status_data: r.status_data,
          store_name: r.store_name,
          supplier_name: r.supplier_name,
          created_by: r.created_by,
          products: r.products || [],
          products_count: r.products_count || 0,
          total_amount: r.total_amount || 0,
          total_amount_actual: r?.total_amount_actual || 0,
          inventory_updated: r.inventory_updated || false,
          created_at: r.created_at,
          updated_at: r.updated_at,
          createdAt: r.createdAt || r.created_at,
          updatedAt: r.updatedAt || r.updated_at,
          purchase_order: r.purchase_order || null,
          menu_options: r.menu_options || []
        }))
      : []

    return {
      success: true,
      total: response.data.total || grns.length,
      data: grns
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch GRN list',
    data: []
  }
}

export const deleteGrn = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'GRN deleted successfully'
    }
  }
  return {
    success: false,
    message: 'Failed to delete GRN'
  }
}

export const createGrn = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'GRN created successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to create GRN',
    data: null
  }
}

export const updateGrn = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'GRN updated successfully',
      data: response.data.data || null
    }
  }
  return {
    success: false,
    message: 'Failed to update GRN',
    data: null
  }
}

export const makeCompleted = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'GRN completed successfully'
    }
  }
  return {
    success: false,
    message: 'Failed to complete GRN'
  }
}
